<!--
 * @Author: awu
 * @Date: 2020-12-01 23:11:41
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-14 21:02:23
 * @Description: 视频播放
-->
<template>
    <div class="video">
        <div class="backHome" @click="backHome">
            <img src="../../assets/user/close.png" alt="" />
        </div>
        <!--<h1 class="video-h1">视频标题</h1>-->
        <!--<video class="video-video video-js vjs-default-skin vjs-big-play-centered" id="video" :src="src" ref="videoPlay" autoplay controls controlslist="nodownload noremoteplayback"></video>-->
        <VideoPlayer :src="src" :type="type" />
        <!-- src="https://static.cloudvhall.com/WENLV/playback-2.m3u8" -->
    </div>
</template>

<script>
import VideoPlayer from '../../components/videoPlayer.vue'

export default {
    name: "Video",
    components: {
      VideoPlayer
    },
    props: {
        src: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: "application/x-mpegURL"
        }
    },
    data() {
        return {
        };
    },
    mounted(){
        this.$nextTick(() => {
            this.getVideo();
        });
    },
    methods: {
        backHome() {
            this.$emit("close");
        },
        getVideo() {
            /*
            this.video = videojs("video", {
                bigPlayButton: true,
                textTrackDisplay: false,
                posterImage: false,
                errorDisplay: false,
                hls: {
                    withCredentials: true
                }
             });
             */
        },
    }
};
</script>

<style lang="scss" scoped>
.video {
    width: 600px;
    height: 393px;
    background: #ffffff;
    box-shadow: 0px 5px 7px 3px rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    padding: 19px 33px;
    &-h1 {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #09468c;
        line-height: 22px;
    }
    &-video {
        width: 544px;
        height: 317px;
        margin-top: 13px;
    }
    .backHome {
        width: 33px;
        height: 33px;
        position: absolute;
        top: 5px;
        right: 21px;
        cursor: pointer;
        border-radius: 50%;
        > img {
            width: 100%;
            height: 100%;
        }
    }
    .backHome:hover {
        background-color: #e8eef4;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/video/index.vue